export default "__VITE_ASSET__BH4R65qA__"